/**
 * Footer contact CTAs (task 86aj16qwa).
 *
 * Makes the @handle, e-mail and phone in the footer contact block clickable
 * (Instagram / mailto / WhatsApp) at runtime. Done in JS — not in the block
 * content — because sections/footer-group.json is auto-generated and the
 * Shopify admin overwrites any markup added there. The contact text stays
 * plain in the JSON; this re-applies the links on every render. The address
 * line (has a <br>) is intentionally left untouched.
 */
function linkifyFooterContact() {
  const block = document.querySelector('[class*="__contact_info"]');
  if (!block) return;

  block.querySelectorAll('p').forEach((paragraph) => {
    if (paragraph.querySelector('a')) return; // already a link
    if (paragraph.querySelector('br')) return; // address block — leave plain

    const raw = paragraph.textContent.trim();
    if (!raw) return;

    let href = null;
    let external = false;

    if (raw.startsWith('@')) {
      href = `https://www.instagram.com/${raw.slice(1).trim().toLowerCase()}`;
      external = true;
    } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)) {
      href = `mailto:${raw.toLowerCase()}`;
    } else if (/^\+?[\d()\s.-]{8,}$/.test(raw)) {
      href = `https://wa.me/${raw.replace(/\D/g, '')}`;
      external = true;
    }

    if (!href) return;

    const link = document.createElement('a');
    link.href = href;
    link.textContent = raw;
    if (external) {
      link.target = '_blank';
      link.rel = 'noopener';
    }
    paragraph.replaceChildren(link);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', linkifyFooterContact);
} else {
  linkifyFooterContact();
}
